<script setup lang="ts">
import { useAppConfigStore } from '../stores/app-config-store';
import { useI18n } from 'vue-i18n';
import RadioButton from 'primevue/radiobutton';

const appConfig = useAppConfigStore();

const { t } = useI18n();
</script>

<template>
    <div class="app-menu-mode-select flex flex-wrap row-gap-3">
        <div
            v-for="menuMode of appConfig.menuModes"
            :key="menuMode"
            class="flex align-items-center gap-2 w-6"
        >
            <RadioButton
                v-model="appConfig.menuMode"
                name="menu-mode"
                :value="menuMode"
                :input-id="`menu-mode-${menuMode}`"
            />
            <label :for="`menu-mode-${menuMode}`">{{
                t(`menuModes.${menuMode}`)
            }}</label>
        </div>
    </div>
</template>
<!-- eslint-disable @intlify/vue-i18n/no-unused-keys -->
<i18n lang="json">
{
    "en": {
        "menuModes": {
            "static": "Static",
            "overlay": "Overlay",
            "slim": "Slim",
            "slim-plus": "Slim+",
            "horizontal": "Horizontal",
            "reveal": "Reveal",
            "drawer": "Drawer"
        }
    },
    "nl": {
        "menuModes": {
            "static": "Statisch",
            "overlay": "Overlap",
            "slim": "Iconen",
            "slim-plus": "Iconen+",
            "horizontal": "Bovenin",
            "reveal": "Schuiven",
            "drawer": "Lade"
        }
    },
    "fr": {
        "menuModes": {
            "static": "Statique",
            "overlay": "Superposé",
            "slim": "Icônes",
            "slim-plus": "Icônes+",
            "horizontal": "Horizontal",
            "reveal": "Déroulant",
            "drawer": "Tiroir"
        }
    }
}
</i18n>
